import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {CogIcon} from '../../icon/svg/cog-icon';

import styles from './cog-button.module.css';

type Props = {
    onClick: () => void;
    size?: number;
    getButtonRef?: any;
};

export function CogButton(props: Props) {
    const {onClick, size, getButtonRef} = props;

    return (
        <button onClick={onClick} type='button' ref={getButtonRef} className={styles.button}>
            <CogIcon size={size || 24} />
        </button>
    );
}
